'use strict';

/* reader.toString() provides the following information
    GLOBAL ATTRIBUTES
      dataset_completeness           = C1+C2
      ms_template_revision           = 1.0.1
      netcdf_revision                = 2.3.2
      languages                      = English
      administrative_comments        = 1% CH2Cl2
      dataset_origin                 = Santa Clara, CA
      netcdf_file_date_time_stamp    = 20161012052159+0200
      experiment_title               = P071 Essence super BP
      experiment_date_time_stamp     = 20070923040800+0200
      operator_name                  = SC
      external_file_ref_0            = FIRE_RTL.M
      experiment_type                = Centroided Mass Spectrum
      number_of_times_processed      = 1
      number_of_times_calibrated     = 0
      sample_state                   = Other State
      test_separation_type           = No Chromatography
      test_ms_inlet                  = Capillary Direct
      test_ionization_mode           = Electron Impact
      test_ionization_polarity       = Positive Polarity
      test_detector_type             = Electron Multiplier
      test_resolution_type           = Constant Resolution
      test_scan_function             = Mass Scan
      test_scan_direction            = Up
      test_scan_law                  = Linear
      raw_data_mass_format           = Float
      raw_data_time_format           = Short
      raw_data_intensity_format      = Float

    VARIABLES:
      error_log                      = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 64)
      a_d_sampling_rate              = [-9999,-9999,-9999,-9999,-9999,-9999,-9999,-9999,- (length: 6401)
      a_d_coaddition_factor          = [-9999,-9999,-9999,-9999,-9999,-9999,-9999,-9999,- (length: 6402)
      scan_acquisition_time          = [5.25,5.84,6.428999999999999,7.019,7.609,8.199,8.7 (length: 6401)
      scan_duration                  = [-9999,-9999,-9999,-9999,-9999,-9999,-9999,-9999,- (length: 6401)
      inter_scan_time                = [-9999,-9999,-9999,-9999,-9999,-9999,-9999,-9999,- (length: 6401)
      resolution                     = [-9999,-9999,-9999,-9999,-9999,-9999,-9999,-9999,- (length: 6401)
      actual_scan_number             = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19 (length: 6401)
      total_intensity                = [3134,3157,3085,3134,3093,3113,3061,3057,3030,3166 (length: 6401)
      mass_range_min                 = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0 (length: 6401)
      mass_range_max                 = [206.89999389648438,206.89999389648438,207,207.100 (length: 6401)
      time_range_min                 = [-9999,-9999,-9999,-9999,-9999,-9999,-9999,-9999,- (length: 6401)
      time_range_max                 = [-9999,-9999,-9999,-9999,-9999,-9999,-9999,-9999,- (length: 6401)
      scan_index                     = [0,11,22,33,44,55,66,76,88,99,111,122,134,145,156, (length: 6401)
      point_count                    = [11,11,11,11,11,11,10,12,11,12,11,12,11,11,11,11,1 (length: 6401)
      flag_count                     = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0 (length: 6401)
      mass_values                    = [16,17,18.100000381469727,28,32,35,36,38,40,44.099 (length: 157201)
      time_values                    = [9.969209968386869e+36,9.969209968386869e+36,9.969 (length: 157201)
      intensity_values               = [37,293,1243,737,420,45,196,72,22,35,34,28,299,123 (length: 157201)
      instrument_name                = ["G","a","s"," ","C","h","r","o","m","a","t","o"," (length: 32)
      instrument_id                  = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_mfr                 = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_model               = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_serial_no           = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_sw_version          = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_fw_version          = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_os_version          = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_app_version         = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
      instrument_comments            = [" "," "," "," "," "," "," "," "," "," "," "," "," (length: 32)
*/

function agilentGCMS(reader) {
  const time = reader.getDataVariable('scan_acquisition_time');
  const tic = reader.getDataVariable('total_intensity');

  // variables to get the mass-intensity values
  const pointCount = reader.getDataVariable('point_count');
  const massValues = reader.getDataVariable('mass_values');
  const intensityValues = reader.getDataVariable('intensity_values');

  var ms = new Array(pointCount.length);
  var index = 0;
  for (var i = 0; i < ms.length; i++) {
    var size = pointCount[i];
    ms[i] = [new Array(size), new Array(size)];

    for (var j = 0; j < size; j++) {
      ms[i][0][j] = massValues[index];
      ms[i][1][j] = intensityValues[index++];
    }
  }

  return {
    times: time,
    series: [
      {
        name: 'tic',
        dimension: 1,
        data: tic
      },
      {
        name: 'ms',
        dimension: 2,
        data: ms
      }
    ]
  };
}

module.exports = agilentGCMS;
